import React, { useEffect } from 'react';

import * as echarts from 'echarts';

import { Title, Container, Legend } from './styles';
import data from './data.json';
import { useGetHeatMapGraphQuery } from 'store/api/pkd/endpoints/graphs';
import { GraphWrapper } from '../AgeGraph/styles';
import { getResizedChartWidth } from 'utils/charts';

import { BasicSkeleton } from 'components/SkeletonLoaders';
import { useGetStatesQuery } from 'store/api/pkd/endpoints/country';
import { Box, Typography } from '@mui/material';

const StatesHeatMapGraph = ({ id, label, width, height }) => {
  const { data: heatMap, isLoading } = useGetHeatMapGraphQuery();
  const { states = [], isStatesLoading } = useGetStatesQuery(null, {
    selectFromResult : ({ data, isLoading }) => ({
      states          : data?.subdivisions,
      isStatesLoading : isLoading,
    }),
  });

  const heatMapData = heatMap
    ?.map(({ state: name, count: value }, index) => {
      return {
        id : index + 1,
        name,
        value,
      };
    })
    .map((state) => {
      const findState = states.find(
        (stateDetails) => stateDetails.code === state.name
      );
      return { ...state, name: findState?.name ?? state.name };
    });
  const maximumHeatMapValue =
    heatMapData && heatMapData.length > 0
      ? Math.max(...heatMapData.map((map) => map.value))
      : 0;

  useEffect(() => {
    var chartDom = document.getElementById(id);
    var myChart = echarts.init(chartDom, null, {
      width,
      height,
    });
    var option;
    echarts.registerMap('USA', data, {
      Alaska : {
        left  : -131,
        top   : 25,
        width : 15,
      },
      Hawaii : {
        left  : -110,
        top   : 28,
        width : 5,
      },
      'Puerto Rico' : {
        left  : -76,
        top   : 26,
        width : 2,
      },
    });
    option = {
      tooltip : {
        trigger            : 'item',
        showDelay          : 0,
        transitionDuration : 0.2,
      },
      visualMap : {
        left  : 'right',
        min   : 0,
        max   : maximumHeatMapValue,
        color : [
          '#2c5092',
          '#5377ad',
          '#81a5cd',
          '#94b9db',
          '#9bbfe0',
          '#b8d7f3',
        ],
        text       : ['High', 'Low'],
        calculable : true,
      },
      series : [
        {
          name      : 'HeatMap',
          type      : 'map',
          roam      : false,
          map       : 'USA',
          itemStyle : {
            emphasis : { label: { show: true } },
          },
          textFixed : {
            Alaska : [20, -20],
          },
          data : heatMapData,
        },
      ],
    };
    myChart.setOption(option);
    const breakpointWidth = 899;
    window.addEventListener('resize', () => {
      const newWidth = getResizedChartWidth(width, breakpointWidth);
      myChart.resize({
        width : newWidth,
      });
    });
    const chartWidth = getResizedChartWidth(width, breakpointWidth);
    myChart.resize({
      width : chartWidth,
    });
    // eslint-disable-next-line
  }, [heatMapData, states.length]);

  const isDataLoading = isLoading || isStatesLoading;

  return (
    <>
      <Title
        variant='h6'
        textAlign={{
          xs : 'center',
          md : 'left',
        }}>
        {label}
      </Title>
      {isDataLoading && <BasicSkeleton
        height='250px'
      />}
      <GraphWrapper
        isVisible={!isDataLoading}>
        <Container>
          <div
            id={id}
          />
          <Legend
            style={{ display: 'flex', justifyContent: 'center' }}>
            ADPKD patients
          </Legend>
        </Container>
      </GraphWrapper>
    </>
  );
};

export default StatesHeatMapGraph;
